import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { FaBoxOpen, FaTags, FaSignOutAlt, FaChartPie } from 'react-icons/fa';

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Protect Routes
    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (!token) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    const navItems = [
        { path: '/admin/products', name: 'Products', icon: <FaBoxOpen /> },
        { path: '/admin/categories', name: 'Categories', icon: <FaTags /> },
    ];

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <h3>Audiopine<span>.Admin</span></h3>
                </div>
                <nav>
                    {navItems.map(item => (
                        <div 
                            key={item.path}
                            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                            onClick={() => navigate(item.path)}
                        >
                            {item.icon} <span>{item.name}</span>
                        </div>
                    ))}
                </nav>
                <div className="sidebar-footer">
                    <button onClick={handleLogout} className="logout-btn">
                        <FaSignOutAlt /> Logout
                    </button>
                </div>
            </aside>
            <main className="admin-content">
                <Outlet />
            </main>

            <style>{`
                .admin-layout { display: flex; min-height: 100vh; background: #0c0c0c; color: #d1d5db; font-family: 'Segoe UI', sans-serif; }
                .admin-sidebar { width: 260px; background: #18181b; border-right: 1px solid #27272a; display: flex; flex-direction: column; position: fixed; height: 100vh; }
                .sidebar-header { padding: 25px; border-bottom: 1px solid #27272a; }
                .sidebar-header h3 { color: white; margin: 0; }
                .sidebar-header span { color: #10b981; }
                .admin-content { margin-left: 260px; flex-grow: 1; padding: 30px; }
                
                nav { padding: 20px; flex-grow: 1; }
                .nav-item { 
                    display: flex; align-items: center; gap: 12px; padding: 12px 15px; 
                    margin-bottom: 5px; border-radius: 6px; cursor: pointer; color: #9ca3af; 
                    transition: 0.2s; 
                }
                .nav-item:hover { background: #27272a; color: white; }
                .nav-item.active { background: #10b981; color: white; }
                
                .sidebar-footer { padding: 20px; border-top: 1px solid #27272a; }
                .logout-btn { 
                    background: none; border: 1px solid #333; color: #ef4444; width: 100%; 
                    padding: 10px; border-radius: 6px; cursor: pointer; display: flex; 
                    align-items: center; justify-content: center; gap: 8px; transition: 0.2s;
                }
                .logout-btn:hover { background: #ef4444; color: white; }

                /* Common Admin Component Styles */
                .admin-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; }
                .admin-btn { background: #10b981; color: white; border: none; padding: 10px 20px; border-radius: 6px; cursor: pointer; font-weight: 600; }
                .admin-table { width: 100%; border-collapse: collapse; background: #18181b; border-radius: 8px; overflow: hidden; }
                .admin-table th, .admin-table td { padding: 15px; text-align: left; border-bottom: 1px solid #27272a; }
                .admin-table th { background: #27272a; color: white; font-weight: 600; }
                .admin-table tr:hover { background: #202023; }
                
                .action-btn { padding: 5px 10px; border-radius: 4px; border: none; cursor: pointer; margin-right: 5px; font-size: 0.8rem; }
                .delete-btn { background: #ef4444; color: white; }
                .edit-btn { background: #3b82f6; color: white; }
                
                /* Form Styles */
                .admin-form-container { background: #18181b; padding: 20px; border-radius: 8px; margin-bottom: 20px; border: 1px solid #333; }
                .form-group { margin-bottom: 15px; }
                .form-group label { display: block; margin-bottom: 5px; color: #9ca3af; font-size: 0.9rem; }
                .form-control { width: 100%; background: #0c0c0c; border: 1px solid #333; color: white; padding: 10px; border-radius: 4px; outline: none; }
                .form-control:focus { border-color: #10b981; }
                .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
            `}</style>
        </div>
    );
};

export default AdminLayout;